/**
 * Constants for 3DS SDK
 */

/**
 * Event type sent when 3DS authentication completes
 */
export const CF_3DS_AUTH_COMPLETE = 'CF_3DS_AUTH_COMPLETE';
/**
 * Event type sent when some error occure
 */
export const CF_AUTH_ERROR = 'CF_AUTH_ERROR';
